import React from 'react'
import styled from 'styled-components'
import { device } from './device'

const Button = styled.a`
    appearance: button;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff !important;
    position: relative;
    cursor: pointer;
    background-color: #FAA735;
    font-family: 'Rubik', sans-serif;
    font-weight: 700;
    border: 0;
    font-size: 14px;
    height: 42px;
    padding: 0 25px;
    border-radius: 1rem;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s, opacity 0.3s, -webkit-transform 0.3s;
    transition: transform 0.3s, box-shadow 0.3s, opacity 0.3s;
    transition: transform 0.3s, box-shadow 0.3s, opacity 0.3s,
        -webkit-transform 0.3s;
    -webkit-transform: translateY(0);
    transform: translateY(0);
    &:hover {
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }
`
const Wrapper = styled.div`
    margin-top: 3rem;
    z-index: 5;
    left: 0;
    text-align: center;
    bottom: 3rem;
    display:flex;
    justify-content: center;

    @media ${device.mobile} {
        bottom: 1%;
    }
`

export default function ExpandButton(props) {
    return (
        <Wrapper className={props.className}>
            <Button
                onClick={props.onClick}
                href={props.href ? props.href : undefined}
            >
                {props.children}
            </Button>
        </Wrapper>
    )
}